// One remembered album password per plaque, kept in this browser for a few days so a revisit opens
// straight away. Storage can be unavailable (private mode), so every access is guarded.
const key = (slug) => `album-pass:${slug}`;

export function rememberPassword(slug, pw, days = 7) {
  try {
    localStorage.setItem(key(slug), JSON.stringify({ pw, exp: Date.now() + days * 24 * 60 * 60 * 1000 }));
  } catch {}
}

export function recallPassword(slug) {
  try {
    const raw = localStorage.getItem(key(slug));
    if (!raw) return null;
    const { pw, exp } = JSON.parse(raw);
    if (!exp || exp <= Date.now()) {
      localStorage.removeItem(key(slug));
      return null;
    }
    return pw;
  } catch {
    return null;
  }
}

export function forgetPassword(slug) {
  try {
    localStorage.removeItem(key(slug));
  } catch {}
}
